






























































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import ApolloClient, { serverBase } from "@/apollo";
import gql from "graphql-tag";
import actorFragment from "@/fragments/actor";
import { contextModule } from "@/store/context";
import InfiniteLoading from "vue-infinite-loading";
import SceneSelector from "@/components/SceneSelector.vue";
import IScene from "@/types/scene";
import IActor from "@/types/actor";
import ILabel from "@/types/label";
import MovieCard from "@/components/MovieCard.vue";
import IMovie from "@/types/movie";
import movieFragment from "@/fragments/movie";
import DrawerMixin from "@/mixins/drawer";
import { mixins } from "vue-class-component";
import { movieModule } from "@/store/movie";

@Component({
  components: {
    InfiniteLoading,
    SceneSelector,
    MovieCard,
  },
})
export default class MovieList extends mixins(DrawerMixin) {
  get showSidenav() {
    return contextModule.showSidenav;
  }

  rerollSeed() {
    const seed = Math.random().toString(36);
    localStorage.setItem("pm_seed", seed);
    if (this.sortBy === "$shuffle") this.loadPage(this.page);
    return seed;
  }

  movies = [] as IMovie[];

  fetchLoader = false;
  fetchError = false;
  fetchingRandom = false;

  moviesBulkText = "" as string | null;
  bulkImportDialog = false;
  bulkLoader = false;

  get showCardLabels() {
    return contextModule.showCardLabels;
  }

  async runBulkImport() {
    this.bulkLoader = true;

    try {
      for (const name of this.moviesBulkImport) {
        await this.createMovieWithName(name);
      }
      this.refreshPage();
      this.bulkImportDialog = false;
    } catch (error) {
      console.error(error);
    }

    this.moviesBulkText = "";
    this.bulkLoader = false;
  }

  get moviesBulkImport() {
    if (this.moviesBulkText) return this.moviesBulkText.split("\n").filter(Boolean);
    return [];
  }

  tryReadLabelsFromLocalStorage(key: string) {
    return (localStorage.getItem(key) || "").split(",").filter(Boolean) as string[];
  }

  allLabels = [] as ILabel[];
  selectedLabels = {
    include: this.tryReadLabelsFromLocalStorage("pm_movieInclude"),
    exclude: this.tryReadLabelsFromLocalStorage("pm_movieExclude"),
  };

  onSelectedLabelsChange(val: any) {
    localStorage.setItem("pm_movieInclude", val.include.join(","));
    localStorage.setItem("pm_movieExclude", val.exclude.join(","));
    this.refreshed = false;
  }

  validCreation = false;
  createMovieDialog = false;
  createMovieName = "";
  createMovieScenes = [] as IScene[];
  addMovieLoader = false;

  movieNameRules = [(v) => (!!v && !!v.length) || "Invalid movie name"];

  query = localStorage.getItem("pm_movieQuery") || "";

  set page(page: number) {
    movieModule.setPage(page);
  }

  get page() {
    return movieModule.page;
  }

  get numResults() {
    return movieModule.numResults;
  }

  get numPages() {
    return movieModule.numPages;
  }

  sortDir = localStorage.getItem("pm_movieSortDir") || "desc";
  sortDirItems = [
    {
      text: "Ascending",
      value: "asc",
    },
    {
      text: "Descending",
      value: "desc",
    },
  ];

  sortBy = localStorage.getItem("pm_movieSortBy") || "relevance";
  sortByItems = [
    {
      text: "Relevance",
      value: "relevance",
    },
    {
      text: "A-Z",
      value: "name",
    },
    {
      text: "Added to collection",
      value: "addedOn",
    },
    {
      text: "Rating",
      value: "rating",
    },
    {
      text: "Duration",
      value: "duration",
    },
    {
      text: "Bookmarked",
      value: "bookmark",
    },
    {
      text: "# scenes",
      value: "numScenes",
    },
    {
      text: "Random",
      value: "$shuffle",
    },
  ];

  favoritesOnly = localStorage.getItem("pm_movieFavorite") == "true";
  bookmarksOnly = localStorage.getItem("pm_movieBookmark") == "true";
  ratingFilter = parseInt(localStorage.getItem("pm_movieRating") || "0");

  openCreateDialog() {
    this.createMovieDialog = true;
  }

  createMovieWithName(name: string) {
    return new Promise((resolve, reject) => {
      ApolloClient.mutate({
        mutation: gql`
          mutation($name: String!) {
            addMovie(name: $name) {
              ...MovieFragment
              actors {
                ...ActorFragment
              }
              scenes {
                _id
              }
            }
          }
          ${movieFragment}
          ${actorFragment}
        `,
        variables: {
          name,
        },
      })
        .then((res) => {
          resolve(res.data.addMovie);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

  addMovie() {
    this.addMovieLoader = true;
    ApolloClient.mutate({
      mutation: gql`
        mutation($name: String!, $scenes: [String!]) {
          addMovie(name: $name, scenes: $scenes) {
            ...MovieFragment
            actors {
              ...ActorFragment
            }
            scenes {
              _id
            }
          }
        }
        ${movieFragment}
        ${actorFragment}
      `,
      variables: {
        name: this.createMovieName,
        scenes: this.createMovieScenes.map((a) => a._id),
      },
    })
      .then((res) => {
        this.refreshPage();
        this.createMovieDialog = false;
        this.createMovieName = "";
        this.createMovieScenes = [];
      })
      .catch(() => {})
      .finally(() => {
        this.addMovieLoader = false;
      });
  }

  movieLabels(movie: any) {
    return movie.labels.map((l) => l.name).sort();
  }

  movieActorNames(movie: any) {
    return movie.actors.map((a) => a.name).join(", ");
  }

  refreshed = true;

  resetPagination() {
    movieModule.resetPagination();
    this.refreshed = true;
    this.loadPage(this.page).catch(() => {
      this.refreshed = false;
    });
  }

  @Watch("ratingFilter")
  onRatingChange(newVal: number) {
    localStorage.setItem("pm_movieRating", newVal.toString());
    this.refreshed = false;
  }

  @Watch("favoritesOnly")
  onFavoriteChange(newVal: boolean) {
    localStorage.setItem("pm_movieFavorite", "" + newVal);
    this.refreshed = false;
  }

  @Watch("bookmarksOnly")
  onBookmarkChange(newVal: boolean) {
    localStorage.setItem("pm_movieBookmark", "" + newVal);
    this.refreshed = false;
  }

  @Watch("sortDir")
  onSortDirChange(newVal: string) {
    localStorage.setItem("pm_movieSortDir", newVal);
    this.refreshed = false;
  }

  @Watch("sortBy")
  onSortChange(newVal: string) {
    localStorage.setItem("pm_movieSortBy", newVal);
    this.refreshed = false;
  }

  @Watch("query")
  onQueryChange(newVal: string | null) {
    localStorage.setItem("pm_movieQuery", newVal || "");
    this.refreshed = false;
  }

  @Watch("selectedLabels")
  onLabelChange() {
    this.refreshed = false;
  }

  getRandom() {
    this.fetchingRandom = true;
    this.fetchPage(1, 1, true, Math.random().toString())
      .then((result) => {
        // @ts-ignore
        this.$router.push(`/movie/${result.items[0]._id}`);
      })
      .catch((err) => {
        this.fetchingRandom = false;
      });
  }

  async fetchPage(page: number, take = 24, random?: boolean, seed?: string) {
    try {
      const result = await ApolloClient.query({
        query: gql`
          query($query: MovieSearchQuery!, $seed: String) {
            getMovies(query: $query, seed: $seed) {
              items {
                ...MovieFragment
                actors {
                  ...ActorFragment
                }
                scenes {
                  _id
                }
              }
              numItems
              numPages
            }
          }
          ${movieFragment}
          ${actorFragment}
        `,
        variables: {
          query: {
            query: this.query || "",
            include: this.selectedLabels.include,
            exclude: this.selectedLabels.exclude,
            take,
            page: page - 1,
            sortDir: this.sortDir,
            sortBy: random ? "$shuffle" : this.sortBy,
            favorite: this.favoritesOnly,
            bookmark: this.bookmarksOnly,
            rating: this.ratingFilter,
          },
          seed: seed || localStorage.getItem("pm_seed") || "default",
        },
      });

      return result.data.getMovies;
    } catch (err) {
      throw err;
    }
  }

  loadPage(page: number) {
    this.fetchLoader = true;

    return this.fetchPage(page)
      .then((result) => {
        this.fetchError = false;
        movieModule.setPagination({
          numResults: result.numItems,
          numPages: result.numPages,
        });
        this.movies = result.items;
      })
      .catch((err) => {
        console.error(err);
        this.fetchError = true;
      })
      .finally(() => {
        this.fetchLoader = false;
      });
  }

  refreshPage() {
    this.loadPage(movieModule.page);
  }

  mounted() {
    if (!this.movies.length) this.refreshPage();
  }

  beforeMount() {
    ApolloClient.query({
      query: gql`
        {
          getLabels {
            _id
            name
            aliases
          }
        }
      `,
    })
      .then((res) => {
        this.allLabels = res.data.getLabels;
        if (!this.allLabels.length) {
          this.selectedLabels.include = [];
          this.selectedLabels.exclude = [];
        }
      })
      .catch((err) => {
        console.error(err);
      });
  }
}
